import React from 'react';

/**
 * Subtitles — large last-spoken phrase with fade-in.
 * When `flash` is provided, an uppercase celebratory overlay replaces the
 * subtitle for ~1s with a scale-up + violet glow animation.
 */
export default function Subtitles({ text, active, speaking, flash }) {
  const empty = !text;

  if (flash) {
    return (
      <div className="sv-subtitle" data-testid="subtitle-text" data-flash="true">
        <span
          key={`flash-${flash.gesture}-${flash.word}`}
          className="sv-subtitle-flash"
          data-testid="subtitle-flash"
          data-gesture={flash.gesture}
        >
          {`¡${flash.word}!`}
        </span>
      </div>
    );
  }

  return (
    <div
      className="sv-subtitle"
      data-testid="subtitle-text"
      data-speaking={speaking ? 'true' : 'false'}
    >
      {empty ? (
        <span className="sv-subtitle-placeholder">
          {active ? 'Show a sign to begin...' : 'Touch Start to begin.'}
        </span>
      ) : (
        <span key={text + (speaking ? '-s' : '-q')} className="sv-subtitle-text">
          {text}
        </span>
      )}
    </div>
  );
}
